import { render, staticRenderFns } from "./SchadenFormular.vue?vue&type=template&id=82dff238&scoped=true&"
import script from "./SchadenFormular.vue?vue&type=script&lang=js&"
export * from "./SchadenFormular.vue?vue&type=script&lang=js&"
import style0 from "./SchadenFormular.vue?vue&type=style&index=0&id=82dff238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dff238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemGroup,VListItemIcon,VListItemTitle})
